import React, { useEffect, useState } from "react";
import "../style/GoogleAds.css";

const GoogleAds = () => {
  const [showAds, setShowAds] = useState(false);
  const [isMobile, setIsMobile] = useState(false);
  const [isAdVisible, setIsAdVisible] = useState(true);

  useEffect(() => {
    // Fetch the config to determine if ads should be shown
    fetch("/assets/config.json")
      .then((response) => response.json())
      .then((config) => {
        setShowAds(config.showAds);
      })
      .catch((error) => {
        console.error("Failed to load the configuration:", error);
      });
  }, []);

  useEffect(() => {
    // Set the isMobile state based on window width
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 767);
    };
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    if (!showAds) return;

    // Load the AdSense script dynamically
    const script = document.createElement("script");
    script.src =
      "https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=ca-pub-1980288183789631";
    script.async = true;
    script.crossOrigin = "anonymous";
    document.body.appendChild(script);
    script.onload = () => {
      try {
        (window.adsbygoogle = window.adsbygoogle || []).push({});
      } catch (e) {
        console.error("AdSense script error:", e);
      }
    };

    script.onerror = () => {
      console.error("Failed to load the AdSense script.");
    };

    return () => {
      document.body.removeChild(script);
    };
  }, [showAds]);

  const handleCloseAd = () => {
    setIsAdVisible(false);
  };

  if (!showAds || !isAdVisible) return null;

  return (
    <div className={`ads-container ${isMobile ? "mobile" : "desktop"}`}>
      <button className="close-ad-button" onClick={handleCloseAd}>
        &times;
      </button>

      {!isMobile && (
        <ins
          className="adsbygoogle"
          style={{ display: "inline-block", width: "160px", height: "600px" }}
          data-ad-client="ca-pub-1980288183789631"
          data-ad-slot="2057721770"
        ></ins>
      )}

      {isMobile && (
        <ins
          className="adsbygoogle"
          style={{
            display: "block",
            width: "300px",
            height: "50px",
            verticalAlign: "bottom",
          }}
          data-ad-client="ca-pub-1980288183789631"
          data-ad-slot="1577804654"
        ></ins>
      )}
    </div>
  );
};

export default GoogleAds;
